module.exports = __webpack_public_path__ + "static/media/GigapetResized.c8400f54.png";